/**
 * 10-point Booking.com style rating helpers.
 *
 * scale: 1.0 — 10.0 (decimal aggregated, integer on a single submission)
 *
 *   9.0–10  Exceptional
 *   8.0–8.9 Very Good
 *   7.0–7.9 Good
 *   6.0–6.9 Pleasant
 *   <6      Review
 */

export const ratingLabel = (val) => {
  const v = Number(val) || 0;
  if (v >= 9) return 'Exceptional';
  if (v >= 8) return 'Very Good';
  if (v >= 7) return 'Good';
  if (v >= 6) return 'Pleasant';
  if (v > 0) return 'Review';
  return 'New';
};

export const ratingBadgeColor = (val) => {
  const v = Number(val) || 0;
  if (v >= 9) return '#16A34A'; // green-600
  if (v >= 8) return '#22C55E'; // green-500
  if (v >= 7) return '#3B82F6'; // blue-500
  if (v >= 6) return '#F59E0B'; // amber-500
  if (v > 0) return '#94A3B8'; // slate-400
  return '#CBD5E1'; // slate-300
};

/** Format e.g. 8.4 → "8.4" (one decimal), or "—" for missing. */
export const formatRating10 = (val) => {
  const v = Number(val);
  if (!v || isNaN(v) || v <= 0) return '—';
  return v.toFixed(1);
};
